import styled from 'styled-components';
import {
  companyColor,
  defaultColor,
  font,
  fluidFont,
  radius,
} from 'styles/theme';

export const Callout = styled.div`
  margin: 1rem 0;
  padding: 0.875rem 1rem;
  border-radius: ${radius('small')};
  background-color: ${defaultColor('backgroundLight')};
  border: 1px solid ${defaultColor('background')};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
`;

export const Label = styled.span`
  font-family: ${font('semibold')};
  ${fluidFont('13px', '15px')};
  color: ${companyColor('font')};
`;

export const Value = styled.span`
  font-family: ${font('semibold')};
  ${fluidFont('13px', '15px')};
  color: ${companyColor('font')};
`;

export const Note = styled.div`
  ${fluidFont('11px', '13px')};
  color: ${defaultColor('gray')};
`;

export const CardSelect = styled.select`
  margin-top: 0.25rem;
  padding: 0.5rem 0.65rem;
  width: 100%;
  border-radius: ${radius('small')};
  border: 1px solid ${defaultColor('background')};
  ${fluidFont('13px', '14px')};
`;
